export default "__VITE_ASSET__C89L2VE0__"